"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _FileCopyOutlined = _interopRequireDefault(require("@mui/icons-material/FileCopyOutlined"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isCopied: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      error
    });
  }
  handleCopy = () => {
    const {
      error
    } = this.state;
    if (error) {
      navigator.clipboard.writeText(error.message);
      this.setState({
        isCopied: true
      });
    }
  };
  handleRefresh = () => {
    window.location.reload();
  };
  render() {
    const {
      error,
      isCopied
    } = this.state;
    const {
      children,
      onLogout
    } = this.props;
    if (error) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        p: 2,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h2",
          children: "Whoops!"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
          children: ["Something went wrong. Please", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
            sx: {
              cursor: 'pointer'
            },
            onClick: this.handleRefresh,
            children: "refresh your browser"
          }), ' ', "and try again! Contact us if your issue is not resolved."]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
          sx: {
            my: 1
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "h5",
            children: "Error:"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            sx: {
              mt: 1,
              p: 2,
              border: 1,
              borderRadius: 4
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
              display: "flex",
              alignItems: "center",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                  variant: "h6",
                  color: "status.error",
                  children: error.message
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
                  title: "Copy error message",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
                    size: "small",
                    onClick: this.handleCopy,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileCopyOutlined.default, {})
                  })
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Collapse.default, {
              in: isCopied,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                variant: "body2",
                color: "status.success",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                  children: "The error message has been copied to your clipboard. "
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                variant: "body2",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                  children: "Please include this error in your ticket."
                })
              })]
            })]
          })]
        }), onLogout && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          onClick: onLogout,
          children: "Logout"
        })]
      });
    }
    return children;
  }
}
var _default = exports.default = ErrorBoundary;